export default function getResource(label, vars = []) {
    const resources = {
        checkboxContentDefaultText: 'J’accepte les',
        checkboxContentDefaultLink: 'modalités de Sephora'
    };
    return resources[label];
}
